<template>
	<div class="ui-tabbar-wrapper">
		<div class="tabbar-wrapper">
			<ul>
				<li class="item" v-for="item in staticData" v-bind:key="item.key" v-on:click="setCurrentActive(item)"
					v-bind:class="{ currentavtive: currentItem == item.link }">
					<!-- <img v-bind:src="item.bgurl" v-if="currentItem != item.link" />
					<img v-bind:src="item.activeBgurl" v-if="currentItem == item.link" />
					<span v-if="cartNumber > 0 && item.link == 'cart' && isOnline">{{ getCarCount }}</span>
					<p v-if="item.name == '我的' && isHasUnreadCount"></p>
					<a>{{ item.name }}</a> -->

					<el-badge :value="getCarCount" :max="99" class="item" v-if="item.link == 'cart'">
						<img v-bind:src="item.bgurl" v-if="currentItem != item.link" />
						<img v-bind:src="item.activeBgurl" v-if="currentItem == item.link" />
						<p v-if="item.name == '我的' && isHasUnreadCount"></p>
						<a>{{ item.name }}</a>
					</el-badge>

					<div v-if="item.link != 'cart'">
						<img v-bind:src="item.bgurl" v-if="currentItem != item.link" />
						<img v-bind:src="item.activeBgurl" v-if="currentItem == item.link" />
						<p v-if="item.name == '我的' && isHasUnreadCount"></p>
						<a>{{ item.name }}</a>
					</div>


				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
	data() {
		return {
			staticData: [
				{
					name: '首页',
					link: 'home',
					key: 0,
					bgurl: require('@/assets/image/home/首页.png'),
					activeBgurl: require('@/assets/image/home/首页 - 选中.png'),
					isActive: true
				},
				{
					name: '产品中心',
					link: 'category',
					key: 1,
					bgurl: require('@/assets/image/home/分类.png'),
					activeBgurl: require('@/assets/image/home/分类 - 选中.png'),
					isActive: false
				},
				{
					name: '积分商城',
					link: 'pointsMall',
					key: 4,
					bgurl: require('@/assets/image/home/积分商城.png'),
					activeBgurl: require('@/assets/image/home/积分商城 - 选中.png'),
					isActive: false
				},
				{
					name: '购物车',
					link: 'cart',
					// params: { type: 1 },
					key: 2,
					bgurl: require('@/assets/image/home/购物车.png'),
					activeBgurl: require('@/assets/image/home/购物车 - 选中.png'),
					isActive: false
				},
				{
					name: '我的',
					link: 'profile',
					key: 3,
					bgurl: require('@/assets/image/home/我的.png'),
					activeBgurl: require('@/assets/image/home/我的 - 选中.png'),
					isActive: false
				}
			],
			currentItem: this.$store.state.tabBar.currentTabBar
				? this.$store.state.tabBar.currentTabBar
				: 'home'
		}
	},

	computed: {
		...mapState({
			currentTabBar: state => state.tabBar.currentTabBar,
			cartNumber: state => state.tabBar.cartNumber,
			isOnline: state => state.auth.isOnline,
			messageHint: state => state.tabBar.messageHint
		}),
		...mapGetters({
			isHasUnreadCount: 'isHasUnreadCount'
		}),
		getCarCount() {
			if (!this.isOnline) {
				return ''
			}
			if (this.cartNumber > 0 && this.cartNumber < 100) {
				return this.cartNumber
			} else if (this.cartNumber >= 100) {
				return '99+'
			}
		}
	},

	watch: {
		currentTabBar: function (value) {
			let data = this.staticData
			for (let i = 0; i <= data.length - 1; i++) {
				if (value == data[i].link) {
					this.currentItem = data[i].link
				}
			}
			if (value !== 'category') {
				this.resetCurrentCategoryItem()
			}
		}
	},

	methods: {
		...mapMutations({
			resetCurrentCategoryItem: 'resetCurrentCategoryItem'
		}),
		setCurrentActive(item) {
			if (!this.isOnline && (item.link == 'cart' || item.link == 'profile' || item.link == 'pointsMall')) {
				this.$router.push({ name: 'signin' })
				return false
			}
			this.currentItem = item.link
			this.$router.push({ name: item.link, params: item.params })
		}
	}
}
// 百度统计服务

// var _hmt = _hmt || [];
// (function() {
//   var hm = document.createElement("script");
//   hm.src = "https://hm.baidu.com/hm.js?de7d9a5bd7d887244ee0370b4975008c";
//   var s = document.getElementsByTagName("script")[0]; 
//   s.parentNode.insertBefore(hm, s);
// })();

var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?3e9f7a61375aaf8f0a2b52986b7d26a2";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
</script>

<style scoped lang="scss">
/deep/ .el-badge__content.is-fixed {
	top: 5px;
	right: 15px;
}

/deep/ .el-badge__content {
	background-color: #ff0000;
}

.ui-tabbar-wrapper {
	position: fixed;
	left: 0px;
	right: 0px;
	bottom: 0px;
	width: 100%;
	height: auto;
	padding: 0px;
	margin: 0px;
	background-color: #ffffff;
	border-top: 1px solid #f0f2f5;
	z-index: 999;

	.tabbar-wrapper {
		ul {
			display: flex;
			-webkit-display: flex;
			-moz-display: flex;
			width: auto;
			justify-content: space-around;
			align-content: center;
			align-items: center;
			height: 60px;

			li {
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				align-items: center;
				position: relative;
				text-align: center;

				img {
					@include wh(30px, 30px);
					@include ilc();
					display: $block;
				}

				a {
					@include sc($fontSize, $mainFontColor);
				}

				// span {
				// 	position: absolute;
				// 	right: -10px;
				// 	background: #ef3338;
				// 	font-size: 12px;
				// 	color: #ffffff;
				// 	border-radius: 10px;
				// 	width: 25px;
				// 	font-weight: normal;
				// 	text-align: center;
				// 	display: inline-block;
				// }

				p {
					width: 7px;
					height: 7px;
					position: absolute;
					right: 0px;
					top: 8%;
					background-color: $primaryColor;
					border-radius: 50%;
				}
			}

			li.currentavtive {
				a {
					color: #eb4b4b;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/Tabbar.vue